import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Video, { IVideoProps } from '../VideoModal';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Link, { ILink } from 'tbk-components/src/components/Button';

export interface ISingleStoryProps extends IBaseElementProps {
	video?: IVideoProps;
	image?: IImage;
	name?: string;
	position?: string;
	preHeading?: string;
	heading?: string;
	text?: string;
	link?: ILink;
}

/**
 * Single Story
 * @block
 * @requiresHooks
 * @icon cover-image
 */
const SingleStory: React.FC<ISingleStoryProps> = ({
	className,
	classNames = [],
	video,
	image,
	name,
	position,
	preHeading,
	heading,
	text,
	link,
}) => (
	<div className={className || cn('single-story', ...classNames)}>
		<div className="single-story__video">
			{video && <Video {...video} />}
			{!video && image && <Image {...image} />}
			{name && <div className="single-story__name">{name}</div>}
			{position && (
				<div className="single-story__position">{position}</div>
			)}
		</div>

		<div className="single-story__content">
			{preHeading && (
				<h3 className="single-story__pre-heading">{preHeading}</h3>
			)}
			{heading && <h2 className="single-story__heading">{heading}</h2>}
			{text && <div className="single-story__text">{text}</div>}
			{link?.label && <Link {...link} className="single-story__link" />}
		</div>
	</div>
);

export default SingleStory;
